import CallEndIcon from '@mui/icons-material/CallEndOutlined';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallbackOutlined';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalkOutlined';
import PhoneMissedIcon from '@mui/icons-material/PhoneMissedOutlined';
import { Call } from '../../model/calls/types';

export const PhoneIcon = ({ started_at, ended_at }: Call['call']) => {
  if (!started_at && !ended_at) return <PhoneCallbackIcon color="warning" />;

  if (started_at && !ended_at) return <PhoneInTalkIcon color="primary" />;

  if (!started_at && ended_at) return <PhoneMissedIcon color="error" />;

  return <CallEndIcon color="disabled" />;
};
